// Libs
import React, { useEffect, useMemo, useState } from 'react';
import * as Yup from 'yup';
import { Collapse, Icon, Divider, Modal } from 'antd';

// Own Libs
import * as ui from '@digital/ui';

//Api
import { CreatBoletimMedicaoPorContrato, CreatMedicao, GetALlBmsPq, GetBoletimMedicaoPorContratoId, getAllBoletimMedicaoPorContrato, obterProxNumBm } from '@app/api/boletimMedicao';
import { getContratoMultiplosGestores } from '@app/api/contrato';

//Files

//Utils
import { hasPermission } from '@app/helpers/permissions';
import { mapToOptions } from '@app/helpers/arrayHelper';
import { isObjEmpty, vtCloneObj } from '@app/helpers/objHelper';
import { getAllPlanilhaQuantidadeMultiplosGestoresByContrato } from '@app/api/contrato/planilhaQuantidadeContrato';

const { Panel } = Collapse;

interface PanelCadastroManualCMGProps {
    contratoId: string;
    onPlanilhaSelecionada: (planilha: any) => void;
}

export function PanelCadastroManualCMG({
    contratoId,
    onPlanilhaSelecionada
}: PanelCadastroManualCMGProps) {

    const [update, setUpdate] = useState(false);
    const onUpdate = () => { setUpdate(!update) }

    const [initialValues, setInitialValues] = useState<CreatBoletimMedicaoPorContrato>({} as CreatBoletimMedicaoPorContrato);

    const [planilhasQuantidade, setPlanilhasQuantidade] = useState<any[]>([]);
    const [bms, setBms] = useState<CreatBoletimMedicaoPorContrato[]>([]);

    const [numBm, setNumBm] = useState(0);

    const [configuracaoContrato] = ui.usePromise(
        () => GetBoletimMedicaoPorContratoId(contratoId),
        [contratoId],
        {} as CreatBoletimMedicaoPorContrato,
    );

    useEffect(() => {
        onPlanilhaSelecionada(initialValues);

        obterProxNumBm(contratoId, initialValues.planilhaDeQuantidadeId)
            .then((numBm: any) => {
                setNumBm(numBm);
            });
    }, [initialValues])

    useEffect(() => {
        const tmpplanilhasQuantidade = planilhasQuantidade.map(f => { f.numero = numBm; return f; });
        setPlanilhasQuantidade(tmpplanilhasQuantidade);
        const tmpBms = bms.map(f => { f.numero = numBm; return f; });
        setBms(tmpBms);

    }, [numBm])

    useEffect(() => {
        const bkpInitialValues = vtCloneObj(initialValues);
        setInitialValues({} as CreatBoletimMedicaoPorContrato);

        getContratoMultiplosGestores(contratoId).then((dataResponsaveis: any) => {
            if (dataResponsaveis && dataResponsaveis.dados) {
                getAllBoletimMedicaoPorContrato(contratoId).then(async (dataBms: GetALlBmsPq | undefined) => {
                    if (dataBms) {

                        let tmp = {} as CreatBoletimMedicaoPorContrato;

                        let result = await getAllPlanilhaQuantidadeMultiplosGestoresByContrato(contratoId);
                        let pqs = dataResponsaveis.dados.map((item: any) => {
                            let aux = result && result.find((aux: any) => {
                                return aux.id === item.planilhaDeQuantidadeId});
                            if (aux) {
                               return { ...item, isResponsavel: aux.isResponsavel };
                            }
                        })

                        if (!hasPermission(['SGC_CONTRATO_VIZUALIZAR_TODAS_SEÇOES_PQ_ASSOCIADAS']) && pqs)
                            pqs = pqs.filter((item: any) => item.isResponsavel);

                        if (isObjEmpty(bkpInitialValues)) {
                            const pq = pqs.reduce((prev: any, current: any) => {
                                const prevNum = Number(prev.planilhaDeQuantidadeNome.replace(/\D/g, ''));
                                const currentNum = Number(current.planilhaDeQuantidadeNome.replace(/\D/g, ''));
                                return prevNum < currentNum ? prev : current;
                            });
                            tmp.planilhaDeQuantidadeId = pq.planilhaDeQuantidadeId
                        } else {
                            tmp = bkpInitialValues
                        }

                        const bm = dataBms.dados.find(f => f.planilhaDeQuantidadeId == tmp.planilhaDeQuantidadeId);
                        if (bm) {
                            tmp = { ...tmp, contratoId: bm.contratoId, numero: bm.numero};
                        }

                        setInitialValues(tmp);
                        setPlanilhasQuantidade(pqs);
                        setBms(dataBms.dados);
                    }
                });
            }
        });


    }, [update]);

    const onSubmitForm = (values: any) => {
        if (values.possuiSla == null || values.possuiSla == undefined)
            values = { ...values, possuiSla: false };

        values.contratoId = contratoId;
        const criarMedicao = () => CreatMedicao(values).then(resp => {
            if (resp && resp.valid) {
                onUpdate();
            }
            return resp;
        });

        if (!values.faturamentoDireto) {
            return criarMedicao();
        }

        return new Promise<any>(resolve => {
            Modal.confirm({
                title: 'Criar BM de faturamento direto?',
                content:
                    'As configurações de NDA, processo de rateio e documentos automáticos serão desativadas somente para este BM. As configurações do contrato não serão alteradas. Deseja continuar?',
                okText: 'Criar BM',
                cancelText: 'Cancelar',
                onOk: () => criarMedicao().then(resolve),
                onCancel: () => resolve(undefined),
            });
        });
    }

    const botoesAcaoGridPqTemporaria = useMemo(() => {
        const actions = [];

        if (hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR'])) {
            actions.push(
                <ui.FormSubmitButton
                    noIcon={true}
                    type="primary"
                    disabled={!hasPermission(['CONTRATO_RESUMO_MEDICOES_CADASTRAR'])}>
                    <ui.FormatText id="ui.commons.save" uppercase />
                </ui.FormSubmitButton>,
            );
        }

        return actions;
    }, []);

    var memoForm = useMemo(() => {

        return (
            <ui.MasterDetailForm
                onSubmit={onSubmitForm}
                initialValues={initialValues}
                validationSchema={Yup.object().shape({
                    periodoInicioData: Yup.string().required('Período inicial deve ser informado'),
                    periodoFimData: Yup.string().required('Período final deve ser informado'),
                    descricao: Yup.string().max(300, 'A descrição deve ter no máximo 300 caracteres').when(['complementar', 'faturamentoDireto'], {
                        is: (complementar: boolean, faturamentoDireto: boolean) => complementar || faturamentoDireto,
                        then: Yup.string().required('A descrição deve ser informada'),
                    })
                })}>
                <ui.Widget actions={botoesAcaoGridPqTemporaria}>

                    <ui.FormSelect
                        showSearch
                        optionFilterProp="children"
                        filterOption={(input, item: any) => {
                            return item.props.children.props.id.toString().toLowerCase().startsWith(input.toLowerCase());
                        }}
                        label="Planilha de Quantidade"
                        name="planilhaDeQuantidadeId"
                        placeholder="Selecione uma opção"
                        options={mapToOptions(planilhasQuantidade, 'planilhaDeQuantidadeId', 'planilhaDeQuantidadeNome')}
                        span={4}
                        allowClear
                        onSelect={(value: any) => {
                            const pq = planilhasQuantidade.find(f => f.planilhaDeQuantidadeId == value);
                            if (pq) {
                                var bm = bms.find(f => pq.identificador == f.identificador || f.planilhaDeQuantidadeId == value);
                                if (bm) {
                                    const temp = {
                                        planilhaDeQuantidadeId: value,
                                        contratoId: bm.contratoId,
                                        numero: bm.numero,
                                        identificador: bm.identificador,
                                    } as CreatBoletimMedicaoPorContrato;
                                    setInitialValues({ ...temp });
                                }
                            }
                        }}
                    />

                    <Divider />

                    <ui.FormInput label="Número do BM" name="numero" value={numBm} span={3} disabled={true} />

                    <ui.FormDatePicker label="Período inicial" name="periodoInicioData" span={3} format="DD/MM/YYYY" />
                    <ui.FormDatePicker label="Período final" name="periodoFimData" span={3} format="DD/MM/YYYY" />
                    <ui.FormSwitch label="Análise de SLA" name="possuiSla" span={3} />

                    <fieldset>
                        <legend>Tipos de Medição</legend>
                        <ui.FormSwitch label="Final" name="final" span={configuracaoContrato.permiteFaturamentoDireto ? 2 : 3} />
                        <ui.FormSwitch label="Periódica" name="periodica" span={configuracaoContrato.permiteFaturamentoDireto ? 2 : 3} />
                        <ui.FormSwitch label="Complementar" name="complementar" span={configuracaoContrato.permiteFaturamentoDireto ? 2 : 3} />
                        {configuracaoContrato.permiteFaturamentoDireto ? (
                            <ui.FormSwitch label="Faturamento Direto" name="faturamentoDireto" span={2} />
                        ) : null}
                        <ui.FormSwitch label="Evento" name="evento" span={configuracaoContrato.permiteFaturamentoDireto ? 2 : 3} />
                    </fieldset>
                    <ui.FormTextArea
                        label="Descrição"
                        name="descricao"
                        span={12}
                        rows={3}
                        maxLength={300}
                        showCount
                        disabled={false}
                        required={initialValues.complementar || initialValues.faturamentoDireto}
                    />
                </ui.Widget>
            </ui.MasterDetailForm>
        );

    }, [initialValues, planilhasQuantidade, bms, numBm, configuracaoContrato.permiteFaturamentoDireto])

    return (
        <>
        <Collapse bordered={false} expandIcon={() => <Icon type="arrows-right_4" />} defaultActiveKey={'medicao'}>
            <Panel key="medicao" header={'Cadastro Manual de Boletim de Medição'} style={{ border: 0 }}>
                {memoForm}
            </Panel>
        </Collapse>
        </>
    )
}
